import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/sections/Header';
import { Footer } from './components/sections/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
/**
 * Scrolls to the hash target after navigating between routes.
 * Lets header/footer links like "/#problem" land on the right section.
 */
function ScrollToHash() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        // wait a tick so the destination route has mounted
        window.setTimeout(() => el.scrollIntoView({
          behavior: 'smooth'
        }), 60);
        return;
      }
    }
    window.scrollTo({
      top: 0,
      left: 0
    });
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <div className="flex min-h-full w-full flex-col bg-white font-body text-text" data-id="element-0">
      <ScrollToHash data-id="element-1" />
      <Header data-id="element-2" />
      <main className="flex-1" data-id="element-3">
        <Routes data-id="element-4">
          <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
          <Route path="/about" element={<About data-id="element-8" />} data-id="element-7" />
        </Routes>
      </main>
      <Footer data-id="element-9" />
    </div>;
}